import { useState, useCallback } from 'react';
function shuffle(a){const b=[...a];for(let i=b.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1));[b[i],b[j]]=[b[j],b[i]];}return b;}
function makeOpts(q){return shuffle([q.a,...shuffle(q.opts).slice(0,3)]);}
export default function TriviaGame({onBack,best,setBest,data,theme}){
  const TOTAL=10;
  const [phase,setPhase]=useState('home');
  const [qs,setQs]=useState([]);
  const [opts,setOpts]=useState([]);
  const [qi,setQi]=useState(0);
  const [sel,setSel]=useState(null);
  const [showLink,setShowLink]=useState(false);
  const [score,setScore]=useState(0);
  const [streak,setStreak]=useState(0);
  const start=useCallback(()=>{
    const q=shuffle(data).slice(0,TOTAL);
    setQs(q);setOpts(makeOpts(q[0]));setQi(0);setSel(null);setShowLink(false);setScore(0);setStreak(0);setPhase('play');
  },[data]);
  const pick=useCallback((opt)=>{
    if(sel!==null)return;setSel(opt);
    const ok=opt===qs[qi].a;
    const ns=ok?score+1:score,nst=ok?streak+1:0;
    setScore(ns);setStreak(nst);if(ns>best)setBest(ns);
  },[sel,qs,qi,score,streak,best,setBest]);
  const next=useCallback(()=>{
    if(qi+1>=TOTAL){setPhase('over');return;}
    const ni=qi+1;setQi(ni);setOpts(makeOpts(qs[ni]));setSel(null);setShowLink(false);
  },[qi,qs]);
  const q=qs[qi],answered=sel!==null,ok=answered&&q&&sel===q.a,pct=(qi/TOTAL)*100;
  const {col,titleClass,pillClass,fillClass,hoverClass,btnClass,panelClass,headClass,textClass,eyebrow,grades,emoji,name}=theme;
  const grade=score>=9?grades[0]:score>=7?grades[1]:score>=5?grades[2]:score>=3?grades[3]:grades[4];
  const cc=(opt)=>{if(!answered)return'choice '+hoverClass;if(opt===q.a)return'choice correct';if(opt===sel)return'choice wrong';return'choice dim';};
  return(<div className="layer" style={{display:'flex',flexDirection:'column',minHeight:'100vh'}}>
    <div className="g-hdr">
      <button className="g-back" onClick={onBack}>← Menu</button>
      <div className={'g-title '+titleClass}>WORLD CUP QUIZ</div>
      {phase==='play'&&<div className="g-pills">
        <div className={'g-pill '+pillClass}><span className="g-plbl">Score</span><span className="g-pval">{score}</span></div>
        <div className={'g-pill '+pillClass}><span className="g-plbl">Streak</span><span className="g-pval">{streak}{streak>=3?'🔥':''}</span></div>
        <div className="g-pill"><span className="g-plbl">Best</span><span className="g-pval">{best}</span></div>
      </div>}
    </div>
    {phase==='home'&&<div className="game-home"><div className="game-inner">
      <div className="game-eye" style={{color:col,border:'1px solid '+col}}>{eyebrow}</div>
      <h1 className="game-big" style={{color:col}}>WORLD<br/>CUP<br/>QUIZ</h1>
      <p className="game-desc">10 questions per round.<br/>Every answer has a <strong style={{color:col}}>real {name} connection</strong>.</p>
      {best>0&&<p className="game-best" style={{color:col}}>Best: {best}/10</p>}
      <button className="btn-gold" style={{marginTop:8}} onClick={start}>KICK OFF</button>
    </div></div>}
    {phase==='over'&&<div className="game-home"><div className="over-card">
      <div className="over-tag" style={{color:col,border:'1px solid '+col}}>FINAL WHISTLE</div>
      <h1 className="over-h1">{grade}</h1>
      <div className="over-stats">
        <div className="over-stat"><span className="over-num" style={{color:col}}>{score}</span><span className="over-lbl">Correct</span></div>
        <div className="over-div"/>
        <div className="over-stat"><span className="over-num" style={{color:col}}>{TOTAL-score}</span><span className="over-lbl">Wrong</span></div>
        <div className="over-div"/>
        <div className="over-stat"><span className="over-num" style={{color:col}}>{best}</span><span className="over-lbl">Best</span></div>
      </div>
      <button className="btn-gold" onClick={start}>PLAY AGAIN</button>
    </div></div>}
    {phase==='play'&&q&&<div className="game-body">
      <div className="prog-row"><div className="prog-bar"><div className={fillClass} style={{width:pct+'%'}}/></div><span className="prog-pct">Q{qi+1}/{TOTAL}</span></div>
      <div className="qcard"><div className={'qcard-label '+pillClass}>Question {qi+1}</div><div className="qcard-q">{q.q}</div></div>
      <div className="choices">{opts.map((opt,i)=><button key={i} className={cc(opt)} onClick={()=>pick(opt)} disabled={answered}>{opt}</button>)}</div>
      {answered&&<>
        <div className={'result-box '+(ok?'ok':'no')}>
          <div className={'result-head '+(ok?'ok':'no')}>{ok?'Correct!':'Answer: '+q.a}</div>
          {q.link&&<button className={'link-btn '+btnClass} onClick={()=>setShowLink(v=>!v)}>{emoji} {showLink?'Hide':'Show'} the {name} connection</button>}
        </div>
        {showLink&&q.link&&<div className={'link-panel '+panelClass}><div className={'lp-head '+headClass}>{name.toUpperCase()} CONNECTION</div><div className={'lp-text '+textClass}>{q.link}</div></div>}
        <div className="game-actions">
          <span className="remaining">{qi+1<TOTAL?(TOTAL-qi-1)+' left':'Last!'}</span>
          <button className="btn-next y" onClick={next}>{qi+1>=TOTAL?'Results →':'Next →'}</button>
        </div>
      </>}
    </div>}
  </div>);
}
